import { createTheme } from "@mui/material/styles";

export const CONTENT_MAX_WIDTH = 980;
// Keep in sync with the .has-sidebar rules in index.css.
export const SIDEBAR_WIDTH = 240;

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#22c55e",
      light: "#4ade80",
      dark: "#15803d",
      contrastText: "#04170d",
    },
    secondary: {
      main: "#2dd4bf",
      light: "#5eead4",
      dark: "#0f766e",
      contrastText: "#021211",
    },
    background: {
      default: "#050a08",
      paper: "#0d1714",
    },
    text: {
      primary: "#ebfff4",
      secondary: "#9fd2b7",
    },
    divider: "rgba(130, 245, 184, 0.2)",
    success: {
      main: "#22c55e",
    },
  },
  shape: {
    borderRadius: 14,
  },
  typography: {
    fontFamily: '"Sora", "Manrope", "Trebuchet MS", sans-serif',
    h5: {
      fontWeight: 700,
      letterSpacing: "0.01em",
    },
    h6: {
      fontWeight: 700,
    },
    button: {
      textTransform: "none",
      fontWeight: 700,
      letterSpacing: "0.01em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#050a08",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(130, 245, 184, 0.12)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid rgba(130, 245, 184, 0.12)",
          boxShadow: "0 12px 30px rgba(0, 0, 0, 0.35)",
        },
      },
    },
    // Desktop layout: page content is capped at CONTENT_MAX_WIDTH and centered.
    MuiContainer: {
      styleOverrides: {
        // Pages nest a Container inside another; don't pad twice, so content lines up with the bars.
        root: {
          "& .MuiContainer-root": { paddingLeft: 0, paddingRight: 0 },
        },
        maxWidthLg: {
          maxWidth: CONTENT_MAX_WIDTH,
          "@media (min-width:1200px)": { maxWidth: CONTENT_MAX_WIDTH },
        },
        maxWidthXl: {
          maxWidth: CONTENT_MAX_WIDTH,
          "@media (min-width:1536px)": { maxWidth: CONTENT_MAX_WIDTH },
        },
      },
    },
    // App bars stay full width, but their buttons/content line up with the page content.
    MuiToolbar: {
      styleOverrides: {
        root: {
          ".MuiAppBar-root > &": {
            width: "100%",
            maxWidth: CONTENT_MAX_WIDTH,
            marginLeft: "auto",
            marginRight: "auto",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage:
            "linear-gradient(120deg, rgba(10, 34, 25, 0.94), rgba(10, 24, 19, 0.92))",
          backdropFilter: "blur(6px)",
          borderBottom: "1px solid rgba(130, 245, 184, 0.15)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundImage:
            "linear-gradient(120deg, #22c55e 0%, #16a34a 45%, #15803d 100%)",
          boxShadow: "0 10px 22px rgba(22, 163, 74, 0.35)",
        },
      },
    },
  },
});

export default theme;
